<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      div(style="width: 28px;")
      v-spacer
      .text-xl.font-bold Share
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      div.text-md.font-semibold.neutral700--text Share this stock take sheet:
      v-row.mt-5(dense align="center")
        v-col
          div.text-lg.font-semibold.neutral700--text {{ stocktake.name }}
        v-col
          div.d-flex.justify-end
            div.clipboard-custom(v-show="showCopied") Link copied!
      v-row(dense)
        v-col
          div
            div.d-flex.align-center
              v-icon(color="neutral700" size="22") $yzi-users-solid-03
              div.text-sm.neutral700--text.ml-3 {{ stocktake.member.name }}
          div
            div.d-flex.align-center
              v-icon.mb-1(color="neutral700" size="22") $yzi-calendar-solid
              div.text-sm.neutral700--text.font-semibold.ml-3 Start date:
              div.text-sm.neutral700--text.ml-1 {{ stocktake.created | humanizeDate }}
          div
            div.d-flex.align-center
              v-icon.mb-1(color="neutral700" size="22") $yzi-clock-check-solid
              div.text-sm.neutral700--text.font-semibold.ml-3 Time started:
              div.text-sm.neutral700--text.ml-1 {{ stocktake.created | displayTime2 }}
        v-col(align="right")
          y-button(label="Copy link" outlined prepend-icon="$yzi-copy-03" icon-size="20" size="sm" @click="copyLink")

    v-card-actions.pb-4.pt-3.px-6
      v-spacer
      y-button(label="Done" text-color="neutral100" color="neutral700" size="md" dark @click="closeDialog")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stocktake: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      showCopied: false
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    copyLink () {
      let textToCopy = encodeURI(`https://${process.env.VUE_APP_BASE_DOMAIN}/stocktake/${this.stocktake.id}`)
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.showCopied = true
          setTimeout(() => {
            this.showCopied = false
          }, 2000)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        })
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
.clipboard-custom {
  font-size: 14px;
  color: white;
  background: var(--v-neutral700);
  padding: 2px 12px;
  border-radius: 6px;
}
</style>